import React from 'react'
import PropTypes from 'prop-types'
import { Card } from 'semantic-ui-react'

const Brand = ({ brand }) => (
  <Card.Description className="product-brand">
    {brand}
  </Card.Description>
)

Brand.propTypes = {
  brand: PropTypes.string,
}
Brand.defaultProps = {
  brand: '',
}

export default Brand



// WEBPACK FOOTER //
// ./src/cms/components/productCard/Brand.js